import {
  AlignItems,
  Box,
  Button,
  ButtonLayout,
  ButtonSize,
  ButtonVariant,
  ColorPreset,
  Dialog,
  Glyph,
  Icon,
  JustifyContent,
  P,
  TextAlign,
  TypePreset,
  ButtonGroup,
} from "@gocardless/flux-react";

import {
  DocumentVerifierProps,
  VerifierState,
} from "./DocumentVerifierContainer";

import { ToTranslate } from "src/components/i18n";

export const VerifyingDocumentDialog = ({
  open,
  setDocumentVerifierState,
}: DocumentVerifierProps) => (
  <>
    <Dialog
      as="div"
      open={open}
      width={["600px", null, "600px"]}
      aria-labelledby="verifying-document-dialog"
      header={{
        content: <></>,
        separator: false,
      }}
      //  the footer is just for the demo to render the document feedback dialog.
      // to be removed when instant document feedback is implemented
      footer={{
        content: (
          <ButtonGroup arrangement={["column-center", null, "row-end-reverse"]}>
            <Button
              variant={ButtonVariant.PrimaryOnLight}
              size={ButtonSize.Sm}
              layout={[ButtonLayout.Full, null, ButtonLayout.Inline]}
              onClick={() =>
                setDocumentVerifierState(VerifierState.DocumentFeedback)
              }
            >
              <ToTranslate>Next</ToTranslate>
            </Button>
          </ButtonGroup>
        ),
        gutterH: 3,
        separator: true,
      }}
    >
      <Box
        layout="flex"
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        spaceBelow={2}
        height={["64px", "64px"]}
      >
        <Icon name={Glyph.SpinnerLight} size="64px" />
      </Box>
      <P
        textAlign={TextAlign.Center}
        preset={TypePreset.Heading_05}
        color={ColorPreset.TextOnLight_01}
        spaceBelow={1}
      >
        Checking your document
      </P>
      <P
        textAlign={TextAlign.Center}
        preset={TypePreset.Body_02}
        color={ColorPreset.TextOnLight_01}
        spaceBelow={1}
        onClick={() => setDocumentVerifierState(VerifierState.UploadDocument)}
        style={{
          textDecoration: "underline",
          cursor: "pointer",
        }}
        role="button"
      >
        Cancel
      </P>
    </Dialog>
  </>
);
